import auth from 'src/router/auth'
import Bank from '../Bank'
import NewBank from '../NewBank'
import EditBank from '../EditBank'
export default [
  {
    path: '/banks',
    name: 'bank',
    component: Bank,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/banks/new',
    name: 'create-bank',
    component: NewBank,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/banks/:id/edit',
    name: 'edit-bank',
    component: EditBank,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/bank/routes/index.js